export function getInitialType(type) {
	if (type) {
		if (!['deposit', 'withdraw'].includes(type)) {
			return 'deposit';
		}
	}

	return type;
}
